import * as React from "react";
import styles from "./styles";
export default (props) => (React.createElement("div", { style: Object.assign({}, styles.container, props.style) }, props.children));
